






































































import Vue, { PropType } from 'vue'
import { debounce } from 'debounce'
import IList from '@/types/components/IList.interface'
import IListTile from '@/types/components/IListTile.interface'
import IListPlaceholder from '@/types/components/IListPlaceholder.interface'
export default Vue.extend({
    props: {
        // The items the list is displaying

        // here is the definition of item
        items: {
            //we bind an array type to the prop and mark. The things in the array are used in the template on line 30
            //dynamic binding because of the methods in the obtaining the information
            //no, ref is static binding because we define it specifically with " ".
            type: Array,
            required: true
        },
        //  Determines if we are paginating or loading data
        loading: {
            type: Boolean,
            default: false
        },
        //  The placeholder shown when the list is empty
        placeholder: {
            type: Object as PropType<IListPlaceholder>,
            default: null
        },
        //   Determines if a 'selected' style is applied to a selected list tile
        selectable: {
            type: Boolean,
            default: false
        },
        //  The currently selected list item
        selected: {
            type: Object,
            default: null
        },
        //  Determines if we have a "Show More" button for pagination
        showMore: {
            type: Boolean,
            default: false
        },
        //  The IListTile display properties
        tile: {
            type: Object as PropType<IListTile>,
            required: true
        },
        //  The id used to store the ilist state in the vuex store (must be unique!)
        id: {
            type: String,
            required: true
        },
        //  The field checked before allowing hover state to be active
        hoverable: {
            type: Object,
            default: null,
            required: false
        }
    },
    data() {
        return {
            //  The currently selected tile (we use this alongside of 'selected' prop for a snappier UI)
            selectedTile: null
        }
    },
    computed: {
        hotKeysEnabled(): boolean {
            // Checks if our hotkeys are enabled or not
            return this.$store.getters.settingGet('hotKeysEnabled')
        },
        //  The persisted stateo of the unique IList
        iList() {
            return this.$store.getters.iList(this.id)
        },
        //  Our number of placeholder elements when we're loading
        placeholderItems(): number[] {
            //  Grab our content container element
            const elem = document.getElementById('content_container')

            //  If for some reason the element doesn't exist, just return 3 items
            if (!elem) return [1, 2, 3]

            //  Else, find out how tall it is
            const height = elem.clientHeight

            //  Each placeholder tile takes up 84px worth of space, so divide our height by 85 (to be safe)
            //  to get # of tiles
            const num = Math.floor(height / 85)

            //  Return an array with this number of elements
            return [...Array(num).keys()]
        },
        //  Determine if the selected Item is NOT in the list
        selectedNotInList() {
            //  If a selected item does NOT exist, return false
            if (!this.selected) return false

            //  Search for the selected item in list items
            const match = this.items.find((x) => x.id === this.selected.id)

            //  If a match was found, the selected item is in the list, so return true
            if (!match) return true

            //  Else, the item wasn't found, so return false
            return false
        }
    },
    mounted() {
        //  If the persisted iList does NOT exist, create it
        if (!this.iList) {
            //  Assemble the iList
            const iList: IList = {
                id: this.id,
                multiSelected: [],
                multiSelect: false,
                selectPage: false
            }

            //  Add the iList to the store
            this.$store.commit('iListSet', iList)
        }
    },
    methods: {
        // Handles ability to navigate Ilist with 'j' and 'k' or arrow keys, event = null is for the function in Inbox.vue called markNew()
        navigation: debounce(function (event = null): void {
            // If we don't have any list items or hotkeys are disabled, leave the function
            if (!this.hotKeysEnabled.enabled || this.items.length <= 0) {
                return
            }

            // If the user hasn't selected a tile yet we select the first for them so they can use nav shortcut
            if (this.selectedTile === null || event === null) {
                /* This if/else statement is for when a user uses ctrl + n and then wants to use the arrow keys again after
                / The way we store items in the list changes the array which breaks arrow key functionality, this way is hacky
                but works */
                if (this.selectedTile !== this.items[0]) this.selectedTile = this.items[0]
                else if (this.selectedNotInList || event === null)
                    this.selectedTile = null
                // Prevents switch case from activating moving the selected item down 1 automatically if user presses down arrow
                return
            }

            // We get the index of the selected tile that's within the items array, we do this as selectedtile.id isn't in order
            let itemIndex = this.items.findIndex((x) => x.id === this.selectedTile.id)

            // Enables use of v-shortkey array and chooses specific case based off of key pressed
            switch (event.srcKey) {
                case 'upArrow':
                case 'jUp':
                    // If we aren't on the top of the list we decrement the item then chose that to be our new selectedtile
                    if (itemIndex === -1) {
                        return
                    }
                    // We move the selected item based off the logic in this function
                    this.moveSelectedItem(true, itemIndex)
                    // We match the scroll position of where our item is and the scroll bar
                    this.scrollPage()
                    break
                case 'downArrow':
                case 'kDown':
                    // If we aren't on the top of the list we decrement the item then chose that to be our new selectedtile
                    if (itemIndex === -1) {
                        return
                    }
                    this.moveSelectedItem(false, itemIndex)
                    this.scrollPage()
                    break
                case 'enter':
                case 'space':
                    // If the user is trying to multi select with the enter key, we add or remove the tile
                    if (this.iList.multiSelect) {
                        // If the tile isn't selected by multi select, add it otherwise remove it from multiselect
                        const isNotSelected = !this.isMultiSelected(this.selectedTile)
                        this.onItemMultiSelected(this.selectedTile, isNotSelected)
                    }
                    // We want the selectedTile to open up the channel if user presses enter so we use it's callback to do so
                    else {
                        this.tile.callback(this.selectedTile)
                    }
                    break
                // Incorrect key press, just return
                default:
                    return
            }
        }, 50),
        // Moves the highlight of an item in ilist either down or up one depending on what key was pressed
        moveSelectedItem(increment: boolean, itemIndex: number): void {
            // We base our list length condition off of what key was pressed. This prevents us from going off of the list
            const listLength = increment
                ? itemIndex > 0
                : itemIndex < this.items.length - 1

            // If we won't go off the list, we then determine what key was pressed and increment/decrement accordingly
            if (listLength) {
                itemIndex = increment ? itemIndex - 1 : itemIndex + 1
                // Assign the selectedtile to our new incremented or decremented item within the ilist
                this.selectedTile = this.items[itemIndex]
            }
        },
        //  Handle the item selected event emitted from a tile
        onItemSelected(item: unknown) {
            this.selectedTile = item
        },
        // Handles the scroll bar when hotkeys are used
        scrollPage(): void {
            // Get the index of the channel that is the same as our selectedTile id
            let itemIndex = this.items.findIndex((x) => x.id === this.selectedTile.id)

            // If our findIndex function fails to find the item we just return
            if (itemIndex === -1) {
                return
            }

            // Otherwise we ensure that our selectedItem is in view by scrolling it automatically
            this.$refs.iListTile[itemIndex].$el.scrollIntoView()
        },
        //  Set the multiSelected list to all items
        selectPage() {
            //  Get the iList from the store
            const iList = this.iList

            //  Set its multiSelected list to page items
            iList.multiSelected = window._.cloneDeep(this.items)

            iList.selectPage = true

            //  Save changes to the store
            this.$store.commit('iListSet', iList)
        },
        //  Reset the multiSelected list to empty array
        selectPageReset() {
            //  Get the iList from the store
            const iList = this.iList

            //  Set its multiSelected list to empty array (ie reset)
            iList.multiSelected = []

            //  Set the 'selectPage' checkbox to fase
            iList.selectPage = false

            //  Save changes to the store
            this.$store.commit('iListSet', iList)
        },
        //  Check if the item is in the multiSelected list
        isMultiSelected(item: any) {
            //  Search for the item in the multiSelected list
            const exists =
                this.iList.multiSelected.findIndex((x) => x.id === item.id) > -1

            //  Return the result
            return exists
        },
        //  Check if the item matches the 'selected' item prop
        isSelected(item: any) {
            //  A selected tile does NOT exist, return false
            if (!this.selectedTile) return false

            //  Else, check if the item matches the selectedTile
            const isSelected = item.id === this.selectedTile.id

            return isSelected
        },
        //  Reset multi-select mode to its default state
        multiSelectReset() {
            //  Get the current IList
            const list = this.iList

            //  Toggle multi-select mode
            list.multiSelect = false

            //  Reset multiselected items
            list.selectPage = false
            list.multiSelected = []

            //  Save the changes
            this.$store.commit('iListSet', list)
        },
        //  Handle the tile multiSelected event, add/removes the item from the multiSelected list
        onItemMultiSelected(item: any, bool: Boolean) {
            //  Get the iList from the store
            const iList = this.iList

            //  Check if the item is already in the list
            const i = iList.multiSelected.findIndex((x) => x.id === item.id)

            //  If the checkbox is 'true', add/replace the item in the multiSelected list
            if (bool) {
                if (i === -1) iList.multiSelected.push(item)
                else iList.multiSelected[i] = item
            }
            //  Else, if the item exists, remove it
            else if (i > -1) iList.multiSelected.splice(i, 1)

            //  Determine the 'selectPage' state
            iList.selectPage = iList.multiSelected.length === this.items.length

            //  Save changes to the store
            this.$store.commit('iListSet', iList)
        },
        //  Get the value for a tile property
        valueGet(item: any, binding: any): any {
            //  Check if the 'binding' is a function
            const isFunction = typeof binding === 'function'

            //  If binding is a function, return the function output
            if (isFunction) return binding(item)

            //  Else, return the binding value
            return binding
        }
    },
    watch: {
        selected(item) {
            //  Check if the item is the same as the currently selected tile
            const isSelected = this.selectedTile?.id === item?.id

            //  If the selected prop is NOT the selectedTile, update the selectedTile
            if (!isSelected) this.selectedTile = item
        }
    }
})
